<div class="public-holidays-container" *ngIf="publicHolidays$ | async as publicHolidays">
  <lx-price-lists-portal-price-list-panel
    [withData]="publicHolidays?.countryPublicHolidays?.length > 0 || publicHolidays?.christmasClosureHolidays?.length > 0"
  >
    <div class="public-holidays-container__title">Public holidays</div>
    <div class="public-holidays">
      <div *ngFor="let countryPublicHolidays of publicHolidays?.countryPublicHolidays">
        <div class="public-holidays__header">
          <lx-header-flag [country]="countryPublicHolidays?.country"></lx-header-flag>
          <div class="public-holidays__header__name">{{ countryPublicHolidays?.country?.name }}</div>
        </div>
        <div class="public-holidays__table">
          <div class="public-holidays__table__row public-holidays__table__header">
            <div class="public-holidays__table__cell public-holidays__table__cell--header">Holidays</div>
            <div class="public-holidays__table__cell public-holidays__table__cell--header">Date</div>
          </div>
          <div class="public-holidays__table__row" *ngFor="let day of countryPublicHolidays.days">
            <div class="public-holidays__table__cell">{{ day.name }}</div>
            <div class="public-holidays__table__cell">{{ day.date | lxDate : dateFormat }}</div>
          </div>
        </div>
      </div>
      <div class="public-holidays__christmas" *ngIf="publicHolidays?.christmasClosureHolidays?.length > 0">
        <div class="public-holidays__christmas__title">Christmas and New Year closure</div>
        <div class="public-holidays__table">
          <div class="public-holidays__table__row-christmas public-holidays__table__header">
            <div class="public-holidays__table__cell public-holidays__table__cell--header public-holidays__table__cell--christmas-country">Country</div>
            <div class="public-holidays__table__cell public-holidays__table__cell--header public-holidays__table__cell--christmas-holidays">Holidays</div>
            <div class="public-holidays__table__cell public-holidays__table__cell--header">Closed</div>
            <div class="public-holidays__table__cell public-holidays__table__cell--header">Open again</div>
          </div>
          <ng-container *ngFor="let christmas of publicHolidays.christmasClosureHolidays">
            <div class="public-holidays__table__row-christmas" *ngFor="let item of christmas.days">
              <div class="public-holidays__table__cell public-holidays__table__cell--christmas-country">{{ christmas.country?.name | uppercase }}</div>
              <div class="public-holidays__table__cell public-holidays__table__cell--christmas-holidays">{{ item.name | uppercase }}</div>
              <div class="public-holidays__table__cell">{{ item.date | lxDate : dateFormat }}</div>
              <div class="public-holidays__table__cell">{{ item.openDate | lxDate : dateFormat }}</div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </lx-price-lists-portal-price-list-panel>
</div>
